import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonToolbar,Row,Col, } from 'react-bootstrap';

class MarkerBlip extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      showInfo: false,
      selected:this.props.selected?this.props.selected:false,
      show:false,
    };
  }
  onMouseEnter = () => {
    this.setState({ showInfo: true });
  }
  onMouseLeave = () => {
    this.setState({ showInfo: false });
  }
  onclick = () => {
    this.setState({ show: true });

  }
  OnClose =() => {
    this.setState({ show: false });
  }
  handleChange(e,hotelId,groupId){
    let checked = e.target.checked;
    let value = {}
    if(checked==true){
      this.setState({ selected: true });
      value = { hotel:hotelId,selected:true,tourgroup_id:groupId };
    }else {
      this.setState({ selected: false });
      value = { hotel:hotelId,selected:false,tourgroup_id:groupId };
    }
    this.props.SelectHotelFromMap(value);
  }

  render() {
    // console.log('MarkerBlip ', this.props);
    let icon = (
      <span className="fa-stack fa-lg">
        <i className="fa fa-stack-2x"></i>
        <i className="fa fa-stack-2x fa-map-marker fa-inverse" style={{color:'green'}}></i>
      </span>
    );
    let name = 'unknown';
    if (this.props.place) {
      name = this.props.place.name;

      icon = (
        <span className="fa-stack fa-lg">
          <i className="fa fa-stack-2x"></i>
          <i className="fa fa-regular fa-stack-2x fa-building fa-inverse" style={{color:'red'}}></i>
        </span>);
    } else {
      name = this.props.name;
    }
    let width = name.length<=47?'200':((name.length>47 && name.length<=100)?350:400)
    let height = name.length<=47?'70':((name.length>47 && name.length<=100)?80:90)
    let style = {
      backgroundColor:'#EDEDED',
      border: '1px solid #777',
      borderRadius:'1em',
      width:width,
      height:height,
      padding: 0,
      margin: 0,
      textAlign:'center',
      position: 'relative',
      zIndex: 9999,
    }
    return (
      <div>
        <div
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
        <a onClick={this.onclick}>{icon}</a>
        </div>
        { this.state.showInfo &&
          <div style={style}>
            <span style={{ margin: 0, fontSize:'18px' }}>{name}</span>
          </div>
        }
        {this.state.show &&
          <div style={style}>
              <a style={{ float:'right',fontSize:'15px' }} onClick={this.OnClose}><i className="fa fa-remove" style={{ bordercolor: 'green'  }}/></a><br/>
              <input
                id={this.props.hotel}
                type="checkbox"
                checked={this.state.selected}
                onChange={(e)=>this.handleChange(e,this.props.hotel,this.props.groupId)}
              />&nbsp;&nbsp;<span style={{ margin: 0,fontSize:'18px' }}>{name}</span>
          </div>
        }
      </div>
    );
  }
}

// HotelMap.propTypes = {
//   hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
//   eventId: PropTypes.number.isRequired,
//   selectHotel: PropTypes.func.isRequired,
//   favoriteHotel: PropTypes.func.isRequired,
// };

export default MarkerBlip;



// WEBPACK FOOTER //
// src/routes/tours/components/MarkerBlip.js